import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORT_TYPES = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_REPORT_TYPES"
);
export const GET_ALL_REPORTS = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_ALL_REPORTS"
);
export const GET_REPORT_KEYS = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_REPORT_KEYS"
);
export const SET_MONTH = "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.SET_MONTH";
export const SET_TO_MONTH = "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.SET_TO_MONTH";
export const SET_YEAR = "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.SET_YEAR";
export const SET_REPORT_TYPE =
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.SET_REPORT_TYPE";
export const GET_JOBPACK_REPORTS = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_JOBPACK_REPORTS"
);
export const BUILD_EXCEL_DOC = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.BUILD_EXCEL_DOC"
);
export const GET_HSQE_TEMPLATE = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_HSQE_TEMPLATE"
);
export const SET_SPECIFIC_TEMPLATE = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.SET_SPECIFIC_TEMPLATE"
);
export const GET_VEHICLE_ALERTS = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_VEHICLE_ALERTS"
);

export const GET_DOWNLOADS = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.GET_DOWNLOADS"
);
export const SET_NEW_DOWNLOAD = restRequest(
    "VRCORE_DASHBOARD_V2.BUILD_EXCEL_WIDGET.SET_NEW_DOWNLOAD"
);